import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Paper, Box, Typography, Chip, CircularProgress, Alert, Grid, Card, CardContent } from '@mui/material';
import { getSkiByQr } from '../api';

export default function PublicSkiInfo() {
  const { qrCode } = useParams();
  const [ski, setSki] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchSki() {
      try {
        const data = await getSkiByQr(qrCode);
        setSki(data);
      } catch (e) {
        setError(e.message || 'Ski not found');
      } finally {
        setLoading(false);
      }
    }
    if (qrCode) fetchSki();
  }, [qrCode]);

  if (loading) return (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}><CircularProgress /></Box>);
  if (error) return (<Container maxWidth="md" sx={{ mt: 4 }}><Alert severity="error">{error}</Alert></Container>);

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 6 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>Ski Information</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="h6" sx={{ mb: 1 }}>Basic Info</Typography>
                <Typography><b>Brand:</b> {ski.brand}</Typography>
                <Typography><b>Ski #:</b> {ski.ski_number}</Typography>
                {ski.serial_number && <Typography><b>Serial #:</b> {ski.serial_number}</Typography>}
                <Typography sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <b>Type:</b>
                  <Chip label={ski.type} color={ski.type === 'classic' ? 'primary' : 'secondary'} size="small" />
                </Typography>
                {ski.ski_length_cm && <Typography><b>Length:</b> {ski.ski_length_cm} cm</Typography>}
                {ski.year_made && <Typography><b>Year:</b> {ski.year_made}</Typography>}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="h6" sx={{ mb: 1 }}>Owner</Typography>
                <Typography><b>Name:</b> {ski.owner_name}</Typography>
                <Typography><b>Contact:</b> {ski.owner_email}</Typography>
              </CardContent>
            </Card>
          </Grid>

          {(ski.fa || ski.hr || ski.mf || ski.h4 || ski.rossi_flex || ski.rossi_height || ski.mold) && (
            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1 }}>Specifications</Typography>
                  <Grid container spacing={2}>
                    {ski.fa && <Grid item xs={6} sm={4}><Typography color="text.secondary">FA</Typography><Typography>{ski.fa}</Typography></Grid>}
                    {ski.hr && <Grid item xs={6} sm={4}><Typography color="text.secondary">HR</Typography><Typography>{ski.hr}</Typography></Grid>}
                    {ski.mf && <Grid item xs={6} sm={4}><Typography color="text.secondary">MF</Typography><Typography>{ski.mf}</Typography></Grid>}
                    {ski.h4 && <Grid item xs={6} sm={4}><Typography color="text.secondary">H4</Typography><Typography>{ski.h4}</Typography></Grid>}
                    {ski.rossi_flex && <Grid item xs={6} sm={4}><Typography color="text.secondary">Flex</Typography><Typography>{ski.rossi_flex}</Typography></Grid>}
                    {ski.rossi_height && <Grid item xs={6} sm={4}><Typography color="text.secondary">Height</Typography><Typography>{ski.rossi_height}</Typography></Grid>}
                    {ski.mold && <Grid item xs={6} sm={4}><Typography color="text.secondary">Mold</Typography><Typography>{ski.mold}</Typography></Grid>}
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}

          {(ski.grind || ski.mold || ski.base) && (
            <Grid item xs={12}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1 }}>Technical</Typography>
                  {ski.grind && <Typography><b>Grind:</b> {ski.grind}</Typography>}
                  {ski.mold && <Typography><b>Mold:</b> {ski.mold}</Typography>}
                  {ski.base && <Typography><b>Base:</b> {ski.base}</Typography>}
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          This read-only view was accessed via QR code.
        </Typography>
      </Paper>
    </Container>
  );
} 